import React from 'react';
import { useUser } from '@lore/auth';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import ParentLayout from '../ParentLayout';
import Urls from '../Urls';
import Form from './Form';
import useRouter from '../../../hooks/useRouter';
import useEvaluationNavigation from '../useEvaluationNavigation';

export default function Layout(props) {
  const { location, history, match } = useRouter();
  const user = useUser();
  const evaluation = useConnect('evaluationProjectEducator.byId', {
    id: Number(match.params.evaluationId)
  });

  const navigation = useEvaluationNavigation(evaluation, Urls(evaluation).UPLOADS);

  if (evaluation.state === PayloadStates.FETCHING) {
    return null;
  }

  return (
    <ParentLayout
      evaluation={evaluation}
      page="Uploads"
      title={(
        <>
          Do you want to share photos of your community-engaged learning experience on the
          platform to celebrate your work and inspire others?
        </>
      )}
    >
      <Form
        user={user}
        evaluation={evaluation}
        navigation={navigation}
        onPrevious={(newData) => history.push(Urls(evaluation).EXCITEMENT)}
        onNext={(newData) => history.push(Urls(evaluation).RECOMMEND)}
        onSkip={() => history.push(Urls(evaluation).RECOMMEND)}
        onExit={() => history.push(Urls(evaluation).PROJECT_VIEW)}
      />
    </ParentLayout>
  );
};
